import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import FormatMessage from '../../messages/FormatMessage';
import { hmiConfig } from '../../hmi.config';

const HmiActions: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp, onApproved, onRejected, language } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }

  const getLocalisedUrl = (url: string): string => {
    return url.replace('$lang', language || 'en');
  };

  return (
    <div className="hmi-actions-footer">
      <div className="sticky-action-panel-content">
        <p className="tos-text">
          <FormatMessage id={'hmi.actions.agreeWithTermsAndPrivacy.part1'} />
          <a
            href={getLocalisedUrl(hmiConfig.links.ownersAgreement)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormatMessage
              id={'hmi.actions.agreeWithTermsAndPrivacy.termsOfService'}
            />
          </a>
          ,{' '}
          <a
            href={getLocalisedUrl(hmiConfig.links.privacyPolicy)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormatMessage
              id={'hmi.actions.agreeWithTermsAndPrivacy.privacyPolicy'}
            />
          </a>
          <FormatMessage id={'hmi.actions.agreeWithTermsAndPrivacy.part2'} />
        </p>

        <div className="action-buttons">
          <button className="secondary-action" onClick={() => onRejected()}>
            <FormatMessage id={'hmi.actions.cancel'} />
          </button>
          <button className="primary-action" onClick={() => onApproved()}>
            <FormatMessage id={'hmi.actions.confirm'} />
          </button>
        </div>

        <p className="hmi-id-text">
          HMI ID: {parentApp.id}-{parentApp.info.version}
        </p>
      </div>
    </div>
  );
};

export default HmiActions;
